import Keycloak from 'keycloak-js';

const authHost = process.env.REACT_APP_KEYCLOAK_HOST ?? '';
const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '';

if ('' === authHost) {
    throw new Error('Configuration missing or empty: authentication host');
}

if ('' === clientId) {
    throw new Error('Configuration missing or empty: authentication client ID');
}

export const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_HOST,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    realm: 'plato',
});

export async function login(options) {
    keycloak.login({
        ...options,
        idpHint: 'saml'
    });
}

export async function logout(options) {
    // Backport the keycloak-js fix that embeds the CSRF token to validate the Logout action (id_token_hint) and return
    // back to the application afterwards (client_id + post_logout_redirect_uri)
    // See https://github.com/keycloak/keycloak/discussions/12183
    const redirectUri = options?.redirectUri ?? window.location.href;
    const logoutUrl = new URL(keycloak.createLogoutUrl({
        ...options,
        redirectUri,
    }));

    logoutUrl.searchParams.set('client_id', keycloak.clientId);
    logoutUrl.searchParams.set('redirect_uri', redirectUri);
    logoutUrl.searchParams.set('post_logout_redirect_uri', redirectUri);

    if (keycloak.idToken) {
        logoutUrl.searchParams.set('id_token_hint', keycloak.idToken);
    }

    window.location.replace(logoutUrl.toString());
}
